import React from "react"
import Form from "../components/Form"

const CampaignPage = () => {
  return (
    <>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <x-dc>
        <helmet>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin=""
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap"
            rel="stylesheet"
          />
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n  html { scroll-behavior: smooth; }\n  body { margin: 0; background: #FFFFFF; color: #111111; font-family: Montserrat, Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased; }\n  * { box-sizing: border-box; }\n  a { color: #111111; text-decoration: none; }\n  a:hover { color: #111111; }\n  input, select, textarea { font-family: inherit; }\n  @keyframes wz-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }\n  @keyframes wz-rise { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }\n",
            }}
          />
        </helmet>
        <div style={{ overflowX: "hidden" }}>
          <header
            style={{
              position: "sticky",
              top: 0,
              zIndex: 60,
              display: "flex",
              alignItems: "center",
              gap: "clamp(16px, 3vw, 44px)",
              padding: "15px clamp(20px, 4vw, 60px)",
              background: "rgba(255,255,255,0.9)",
              backdropFilter: "blur(16px)",
              borderBottom: "1px solid rgba(17,17,17,0.09)",
            }}
          >
            <img
              style={{
                fontWeight: 700,
                fontSize: 21,
                maxWidth: 112,
              }}
              src="https://www.wizito.com/logo-noir.png"
            ></img>
            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                gap: 18,
              }}
            >
              <span
                style={{
                  fontFamily: "Montserrat, Helvetica, sans-serif",
                  fontSize: "13.5px",
                  color: "rgba(17,17,17,0.7)",
                }}
              >
                01 84 60 61 64
              </span>
              <a
                href="#devis"
                style={{
                  background: "#111111",
                  color: "#FFFFFF",
                  padding: "12px 22px",
                  borderRadius: 999,
                  fontSize: 14,
                  fontWeight: 700,
                  letterSpacing: "-0.01em",
                }}
                style-hover="background: #CE2D7B; color: #FFFFFF"
              >
                Demander un devis
              </a>
            </div>
          </header>
          <section
            id="top"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(430px, 1fr))",
              gap: "clamp(28px, 3.5vw, 60px)",
              alignItems: "center",
              padding:
                "clamp(44px, 5.5vw, 92px) clamp(20px, 4vw, 60px) clamp(30px, 4vw, 56px)",
              maxWidth: 1560,
              margin: "0 auto",
            }}
          >
            <div style={{ animation: "wz-rise 0.6s ease both" }}>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 9,
                  fontFamily: "Montserrat, Helvetica, sans-serif",
                  fontSize: "11.5px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  padding: "8px 15px",
                  border: "1px solid rgba(17,17,17,0.16)",
                  borderRadius: 10,
                  marginBottom: 26,
                  color: "rgba(17,17,17,0.7)",
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#A85B32",
                  }}
                />
                Bornes photo made in France · Événementiel B2B
              </div>
              <h1
                style={{
                  fontFamily: "Montserrat, Helvetica, sans-serif",
                  fontWeight: 700,
                  fontSize: "clamp(42px, 5.4vw, 82px)",
                  lineHeight: "0.95",
                  letterSpacing: "-0.04em",
                  margin: "0 0 22px",
                }}
              >
                Une animation photo
                <br />
                qui transforme un événement
                <br />
                en souvenir.
              </h1>
              <p
                style={{
                  fontSize: "clamp(16px, 1.2vw, 19px)",
                  lineHeight: "1.62",
                  maxWidth: "31em",
                  margin: "0 0 34px",
                  color: "rgba(17,17,17,0.7)",
                  textWrap: "pretty",
                }}
              >
                Un événement se termine, un souvenir reste. Nos bornes photo
                personnalisables impriment sur place ce que vos invités
                garderont de votre séminaire, salon ou soirée.
                <br />
                Installation, exploitation et démontage assurés par nos équipes.
              </p>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 12,
                  marginBottom: 40,
                }}
              >
                <a
                  href="#devis"
                  style={{
                    background: "#CE2D7B",
                    color: "#FFFFFF",
                    padding: "18px 32px",
                    borderRadius: 999,
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                  style-hover="background: #111111"
                >
                  Obtenir mon devis sous 24 h
                </a>
                <a
                  href="#bornes"
                  style={{
                    padding: "18px 30px",
                    borderRadius: 999,
                    fontSize: 16,
                    fontWeight: 700,
                    border: "1px solid #5AA1D8",
                    color: "#1B5B8C",
                  }}
                  style-hover="background: #EDF5FB; border-color: #1B5B8C"
                >
                  Explorer nos scénographies
                </a>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(120px, auto))",
                  gap: "22px 30px",
                  justifyContent: "start",
                  borderTop: "1px solid rgba(17,17,17,0.12)",
                  paddingTop: 24,
                }}
              >
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontSize: 25,
                      letterSpacing: "-0.03em",
                      marginBottom: 3,
                    }}
                  >
                    3 000
                  </strong>
                  <span style={{ fontSize: 13, color: "rgba(17,17,17,0.6)" }}>
                    clients B2B
                  </span>
                </div>
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontSize: 25,
                      letterSpacing: "-0.03em",
                      marginBottom: 3,
                    }}
                  >
                    500
                  </strong>
                  <span style={{ fontSize: 13, color: "rgba(17,17,17,0.6)" }}>
                    événements par mois
                  </span>
                </div>
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontSize: 25,
                      letterSpacing: "-0.03em",
                      marginBottom: 3,
                    }}
                  >
                    5 bureaux
                  </strong>
                  <span style={{ fontSize: 13, color: "rgba(17,17,17,0.6)" }}>
                    en France
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{
                position: "relative",
                alignSelf: "start",
                marginTop: 24,
              }}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  overflow: "hidden",
                  borderRadius: 24,
                  aspectRatio: "4 / 3.5",
                  background: "rgba(255,239,92,0.7)",
                  padding: 25,
                  boxShadow: "0 34px 70px -34px rgba(17,17,17,0.4)",
                }}
              >
                <video
                  src="https://storage.googleapis.com/wizito-website2/rokoriko_6d506f846e/rokoriko_6d506f846e.mp4"
                  autoPlay="{{ true }}"
                  loop="{{ true }}"
                  muted="{{ true }}"
                  playsInline="{{ true }}"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                    borderRadius: 24,
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
          </section>
          <div
            style={{
              background: "#111111",
              color: "#FFFFFF",
              overflow: "hidden",
              padding: "17px 0",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "max-content",
                animation: "wz-marquee 38s linear infinite",
                fontFamily: "Montserrat, Helvetica, sans-serif",
                fontSize: "12.5px",
                letterSpacing: "0.06em",
                textTransform: "uppercase",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 38,
                  paddingRight: 38,
                  opacity: "0.85",
                }}
              >
                <span>Made in France</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Impressions illimitées</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Installation &amp; démontage inclus</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Borne 100 % personnalisable</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Collecte de données RGPD</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Livraison partout en France</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Chef de projet dédié</span>
                <span style={{ opacity: "0.4" }}>/</span>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 38,
                  paddingRight: 38,
                  opacity: "0.85",
                }}
              >
                <span>Made in France</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Impressions illimitées</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Installation &amp; démontage inclus</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Borne 100 % personnalisable</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Collecte de données RGPD</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Livraison partout en France</span>
                <span style={{ opacity: "0.4" }}>/</span>
                <span>Chef de projet dédié</span>
                <span style={{ opacity: "0.4" }}>/</span>
              </div>
            </div>
          </div>
          <sc-if value="{{ showLogoBand }}" hint-placeholder-val="{{ true }}">
            <section
              style={{
                padding: "clamp(34px, 4vw, 58px) clamp(20px, 4vw, 60px)",
              }}
            >
              <p
                style={{
                  fontFamily: "Montserrat, Helvetica, sans-serif",
                  fontSize: "11.5px",
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "rgba(17,17,17,0.45)",
                  margin: "0 0 24px",
                  textAlign: "center",
                }}
              >
                Plus de 3 000 clients B2B accompagnés
              </p>
              <div
                style={{
                  maxWidth: 1180,
                  margin: "0 auto",
                  display: "grid",
                  gap: 18,
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    height: 38,
                    maskImage:
                      "linear-gradient(to right, transparent, #000 4%, #000 96%, transparent)",
                  }}
                >
                  <img
                    src="https://storage.googleapis.com/wizito-website2/bande_de_logos_7b192b386b/bande_de_logos_7b192b386b.webp"
                    alt="Marques accompagnées par Wizito"
                    style={{
                      display: "block",
                      height: 38,
                      width: "auto",
                      maxWidth: "none",
                    }}
                  />
                </div>
                <div
                  style={{
                    overflow: "hidden",
                    height: 38,
                    maskImage:
                      "linear-gradient(to right, transparent, #000 4%, #000 96%, transparent)",
                  }}
                >
                  <img
                    src="https://storage.googleapis.com/wizito-website2/bande_de_logos_7b192b386b/bande_de_logos_7b192b386b.webp"
                    alt=""
                    style={{
                      display: "block",
                      height: 38,
                      width: "auto",
                      maxWidth: "none",
                      marginLeft: "-100%",
                    }}
                  />
                </div>
              </div>
            </section>
          </sc-if>
          <section
            id="bornes"
            style={{
              padding: "clamp(44px, 5vw, 88px) clamp(20px, 4vw, 60px)",
              maxWidth: 1560,
              margin: "0 auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: 22,
                marginBottom: 40,
              }}
            >
              <div>
                <p
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontSize: "11.5px",
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    color: "#CE2D7B",
                    margin: "0 0 14px",
                  }}
                >
                  Nos animations
                </p>
                <h2
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 700,
                    fontSize: "clamp(30px, 3.3vw, 50px)",
                    letterSpacing: "-0.035em",
                    lineHeight: "1.02",
                    margin: 0,
                    maxWidth: "20em",
                  }}
                >
                  Trois bornes, un même standard de qualité
                </h2>
              </div>
              <p
                style={{
                  fontSize: "15.5px",
                  lineHeight: "1.6",
                  color: "rgba(17,17,17,0.65)",
                  maxWidth: "30em",
                  margin: 0,
                }}
              >
                Reflex, flash professionnel, écran tactile et imprimante
                thermique haute capacité sur toute la gamme. On choisit ensemble
                le modèle selon votre espace, votre scénographie et votre nombre
                d'invités.
              </p>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: 18,
              }}
            >
              <article
                style={{
                  background: "#F7F7F7",
                  borderRadius: 18,
                  overflow: "hidden",
                  border: "1px solid rgba(17,17,17,0.08)",
                  display: "flex",
                  flexDirection: "column",
                }}
                style-hover="border-color: rgba(17,17,17,0.28)"
              >
                <div
                  style={{
                    aspectRatio: "4 / 3.2",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src="https://www.wizito.com/static/4790c8099e66dd0e382c50c944babfc8/bd81f/Lyon_1_18b4494494.webp"
                    alt="Wonder Booth Wizito"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 14,
                      left: 14,
                      background: "#FFEF5C",
                      color: "#111111",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontSize: "10.5px",
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      padding: "6px 10px",
                      borderRadius: 10,
                    }}
                  >
                    Best-seller
                  </span>
                </div>
                <div
                  style={{
                    padding: "22px 22px 24px",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                  }}
                >
                  <h3
                    style={{
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: 22,
                      letterSpacing: "-0.02em",
                      margin: "0 0 8px",
                    }}
                  >
                    Wonder Booth
                  </h3>
                  <p
                    style={{
                      fontSize: "14.5px",
                      lineHeight: "1.55",
                      color: "rgba(17,17,17,0.68)",
                      margin: "0 0 20px",
                    }}
                  >
                    Le must-have de vos événements. Silhouète fine et élégante
                    avec ses pieds en bois, s'intègre partout.
                  </p>
                  <dl
                    style={{
                      margin: "0 0 22px",
                      display: "grid",
                      gridTemplateColumns: "auto 1fr",
                      gap: "9px 16px",
                      fontSize: "13.5px",
                    }}
                  >
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Dimensions</dt>
                    <dd style={{ margin: 0 }}>60 × 60 × 170 cm</dd>
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Poids</dt>
                    <dd style={{ margin: 0 }}>60 kg</dd>
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Recul</dt>
                    <dd style={{ margin: 0 }}>2 m</dd>
                  </dl>
                  <a
                    href="#devis"
                    style={{
                      marginTop: "auto",
                      fontSize: "14.5px",
                      fontWeight: 700,
                      color: "#CE2D7B",
                    }}
                    style-hover="color: #111111"
                  >
                    Chiffrer cette borne →
                  </a>
                </div>
              </article>
              <article
                style={{
                  background: "#F7F7F7",
                  borderRadius: 18,
                  overflow: "hidden",
                  border: "1px solid rgba(17,17,17,0.08)",
                  display: "flex",
                  flexDirection: "column",
                }}
                style-hover="border-color: rgba(17,17,17,0.28)"
              >
                <div style={{ aspectRatio: "4 / 3.2", overflow: "hidden" }}>
                  <img
                    src="https://drive.google.com/thumbnail?id=1IWMMWRqmZkQ3wjjExftVTt3auqwxB20K&sz=w1600"
                    alt="Sky Booth Wizito"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center 35%",
                      display: "block",
                    }}
                  />
                </div>
                <div
                  style={{
                    padding: "22px 22px 24px",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                  }}
                >
                  <h3
                    style={{
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: 22,
                      letterSpacing: "-0.02em",
                      margin: "0 0 8px",
                    }}
                  >
                    Sky Booth
                  </h3>
                  <p
                    style={{
                      fontSize: "14.5px",
                      lineHeight: "1.55",
                      color: "rgba(17,17,17,0.68)",
                      margin: "0 0 20px",
                    }}
                  >
                    La borne photo vue d'en haut : sa perche atteint 3m50 pour
                    cadrer les grands groupes.
                  </p>
                  <dl
                    style={{
                      margin: "0 0 22px",
                      display: "grid",
                      gridTemplateColumns: "auto 1fr",
                      gap: "9px 16px",
                      fontSize: "13.5px",
                    }}
                  >
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Dimensions</dt>
                    <dd style={{ margin: 0 }}>50 × 50 × 200 à 350 cm</dd>
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Poids</dt>
                    <dd style={{ margin: 0 }}>80 kg</dd>
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Recul</dt>
                    <dd style={{ margin: 0 }}>1 à 2 m</dd>
                  </dl>
                  <a
                    href="#devis"
                    style={{
                      marginTop: "auto",
                      fontSize: "14.5px",
                      fontWeight: 700,
                      color: "#CE2D7B",
                    }}
                    style-hover="color: #111111"
                  >
                    Chiffrer cette borne →
                  </a>
                </div>
              </article>
              <article
                style={{
                  background: "#F7F7F7",
                  borderRadius: 18,
                  overflow: "hidden",
                  border: "1px solid rgba(17,17,17,0.08)",
                  display: "flex",
                  flexDirection: "column",
                }}
                style-hover="border-color: rgba(17,17,17,0.28)"
              >
                <div style={{ aspectRatio: "4 / 3.2", overflow: "hidden" }}>
                  <img
                    src="https://www.wizito.com/static/4873f3009cbd4e95f2a563931cb14988/59eb3/Iron_Booth_4855c09397.webp"
                    alt="Iron Booth Wizito"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>
                <div
                  style={{
                    padding: "22px 22px 24px",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                  }}
                >
                  <h3
                    style={{
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: 22,
                      letterSpacing: "-0.02em",
                      margin: "0 0 8px",
                    }}
                  >
                    Iron Booth
                  </h3>
                  <p
                    style={{
                      fontSize: "14.5px",
                      lineHeight: "1.55",
                      color: "rgba(17,17,17,0.68)",
                      margin: "0 0 20px",
                    }}
                  >
                    La visibilité à son maximum. Parfait pour vos événements
                    grand public à fort passage !
                  </p>
                  <dl
                    style={{
                      margin: "0 0 22px",
                      display: "grid",
                      gridTemplateColumns: "auto 1fr",
                      gap: "9px 16px",
                      fontSize: "13.5px",
                    }}
                  >
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Dimensions</dt>
                    <dd style={{ margin: 0 }}>70 × 70 × 175 cm</dd>
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Poids</dt>
                    <dd style={{ margin: 0 }}>180 kg</dd>
                    <dt style={{ color: "rgba(17,17,17,0.5)" }}>Recul</dt>
                    <dd style={{ margin: 0 }}>1 à 3 m</dd>
                  </dl>
                  <a
                    href="#devis"
                    style={{
                      marginTop: "auto",
                      fontSize: "14.5px",
                      fontWeight: 700,
                      color: "#CE2D7B",
                    }}
                    style-hover="color: #111111"
                  >
                    Chiffrer cette borne →
                  </a>
                </div>
              </article>
            </div>
          </section>
          <section
            id="animations"
            style={{
              background: "#1B5B8C",
              color: "#FFFFFF",
              padding: "clamp(48px, 5.5vw, 96px) clamp(20px, 4vw, 60px)",
            }}
          >
            <div style={{ maxWidth: 1560, margin: "0 auto" }}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  gap: 22,
                  marginBottom: 40,
                }}
              >
                <div>
                  <p
                    style={{
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontSize: "11.5px",
                      letterSpacing: "0.12em",
                      textTransform: "uppercase",
                      color: "#FFEF5C",
                      margin: "0 0 14px",
                    }}
                  >
                    Les décors
                  </p>
                  <h2
                    style={{
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: "clamp(30px, 3.3vw, 50px)",
                      letterSpacing: "-0.035em",
                      lineHeight: "1.02",
                      margin: 0,
                      maxWidth: "22em",
                    }}
                  >
                    Au-delà de la borne : une scénographie complète
                  </h2>
                </div>
                <p
                  style={{
                    fontSize: "15.5px",
                    lineHeight: "1.6",
                    color: "rgba(255,255,255,0.85)",
                    maxWidth: "28em",
                    margin: 0,
                  }}
                >
                  Plus d'une dizaine d'univers personnalisables, livrés,
                  installés et repris par nos équipes.
                </p>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    borderRadius: 18,
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.12)",
                  }}
                >
                  <div style={{ aspectRatio: "4 / 3.4", overflow: "hidden" }}>
                    <img
                      src="https://www.wizito.com/static/d621c1a1ca7fe37954150de34c96ffc9/d1ef5/Cover_piscine_c0bfdbd2d4.webp"
                      alt="Animation piscine à balles Wizito"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        display: "block",
                      }}
                    />
                  </div>
                  <div style={{ padding: "18px 18px 20px" }}>
                    <h3
                      style={{
                        fontFamily: "Montserrat, Helvetica, sans-serif",
                        fontWeight: 600,
                        fontSize: "17.5px",
                        letterSpacing: "-0.02em",
                        margin: "0 0 7px",
                      }}
                    >
                      Piscine à balles
                    </h3>
                    <p
                      style={{
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "rgba(255,255,255,0.82)",
                        margin: 0,
                      }}
                    >
                      Une animation iconique qui attire les foules et vous
                      promet de belles batailles !
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    borderRadius: 18,
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.12)",
                  }}
                >
                  <div style={{ aspectRatio: "4 / 3.4", overflow: "hidden" }}>
                    <img
                      src="https://www.wizito.com/static/b79b37e97f803d38879b0b038c87404f/6c9a2/Photocall_fleuri_2_5999cf3211.webp"
                      alt="Animation balançoire Wizito"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center 38%",
                        display: "block",
                      }}
                    />
                  </div>
                  <div style={{ padding: "18px 18px 20px" }}>
                    <h3
                      style={{
                        fontFamily: "Montserrat, Helvetica, sans-serif",
                        fontWeight: 600,
                        fontSize: "17.5px",
                        letterSpacing: "-0.02em",
                        margin: "0 0 7px",
                      }}
                    >
                      Balançoire
                    </h3>
                    <p
                      style={{
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "rgba(255,255,255,0.82)",
                        margin: 0,
                      }}
                    >
                      Parfait pour retourner en enfance le temps d'une photo
                      mais aussi pour réaliser votre nouvelle photo insta.
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    borderRadius: 18,
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.12)",
                  }}
                >
                  <div style={{ aspectRatio: "4 / 3.4", overflow: "hidden" }}>
                    <img
                      src="https://www.wizito.com/static/5a269769f1176cfcf45d4421a277fe44/d1ef5/Cover_telesiege_b5bddb0224.webp"
                      alt="Animation télésiège Wizito"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </div>
                  <div style={{ padding: "18px 18px 20px" }}>
                    <h3
                      style={{
                        fontFamily: "Montserrat, Helvetica, sans-serif",
                        fontWeight: 600,
                        fontSize: "17.5px",
                        letterSpacing: "-0.02em",
                        margin: "0 0 7px",
                      }}
                    >
                      Télésiège
                    </h3>
                    <p
                      style={{
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "rgba(255,255,255,0.82)",
                        margin: 0,
                      }}
                    >
                      LE décor thématique de vos Winter Party, l'animation qui
                      met tout de suite l'ambiance montagne dans la salle.
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    borderRadius: 18,
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.12)",
                  }}
                >
                  <div style={{ aspectRatio: "4 / 3.4", overflow: "hidden" }}>
                    <img
                      src="https://www.wizito.com/static/8dccfcf3e7069ab7e8da454baf8f02e5/d1ef5/Cover_box_fermee_95a0e3d9c7.webp"
                      alt="Box fermée Wizito"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        display: "block",
                      }}
                    />
                  </div>
                  <div style={{ padding: "18px 18px 20px" }}>
                    <h3
                      style={{
                        fontFamily: "Montserrat, Helvetica, sans-serif",
                        fontWeight: 600,
                        fontSize: "17.5px",
                        letterSpacing: "-0.02em",
                        margin: "0 0 7px",
                      }}
                    >
                      Box fermée
                    </h3>
                    <p
                      style={{
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "rgba(255,255,255,0.82)",
                        margin: 0,
                      }}
                    >
                      Une cabine de shooting à part, conçue pour repousser les
                      codes classiques du photobooth.
                    </p>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 34,
                }}
              >
                <a
                  href="https://www.wizito.com/animation-photobooth"
                  style={{
                    background: "#FFEF5C",
                    color: "#111111",
                    padding: "17px 34px",
                    borderRadius: 999,
                    fontSize: 16,
                    fontWeight: 700,
                  }}
                  style-hover="background: #FFFFFF"
                >
                  Voir tous nos décors
                </a>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 26,
                  marginTop: "clamp(44px, 5vw, 80px)",
                  borderTop: "1px solid rgba(255,255,255,0.15)",
                  paddingTop: "clamp(32px, 4vw, 52px)",
                  alignItems: "stretch",
                  justifyContent: "stretch",
                }}
              >
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: "clamp(38px, 4.4vw, 64px)",
                      letterSpacing: "-0.04em",
                      lineHeight: 1,
                      color: "#FFEF5C",
                    }}
                  >
                    10
                  </strong>
                  <span
                    style={{
                      fontSize: "14.5px",
                      color: "rgba(255,255,255,0.85)",
                    }}
                  >
                    ans d'événementiel
                  </span>
                </div>
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: "clamp(38px, 4.4vw, 64px)",
                      letterSpacing: "-0.04em",
                      lineHeight: 1,
                      color: "#FFEF5C",
                    }}
                  >
                    33
                  </strong>
                  <span
                    style={{
                      fontSize: "14.5px",
                      color: "rgba(255,255,255,0.85)",
                    }}
                  >
                    passionnés
                  </span>
                </div>
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: "clamp(38px, 4.4vw, 64px)",
                      letterSpacing: "-0.04em",
                      lineHeight: 1,
                      color: "#FFEF5C",
                    }}
                  >
                    5
                  </strong>
                  <span
                    style={{
                      fontSize: "14.5px",
                      color: "rgba(255,255,255,0.85)",
                    }}
                  >
                    villes en France
                  </span>
                </div>
                <div>
                  <strong
                    style={{
                      display: "block",
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: "clamp(38px, 4.4vw, 64px)",
                      letterSpacing: "-0.04em",
                      lineHeight: 1,
                      color: "#FFEF5C",
                    }}
                  >
                    1200
                  </strong>
                  <span
                    style={{
                      fontSize: "14.5px",
                      color: "rgba(255,255,255,0.85)",
                    }}
                  >
                    m² de stock
                  </span>
                </div>
              </div>
            </div>
          </section>
          <section
            id="process"
            style={{
              padding: "clamp(48px, 5.5vw, 92px) clamp(20px, 4vw, 60px)",
              maxWidth: 1560,
              margin: "0 auto",
            }}
          >
            <p
              style={{
                fontFamily: "Montserrat, Helvetica, sans-serif",
                fontSize: "11.5px",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "#CE2D7B",
                margin: "0 0 14px",
              }}
            >
              Le déroulé
            </p>
            <h2
              style={{
                fontFamily: "Montserrat, Helvetica, sans-serif",
                fontWeight: 700,
                fontSize: "clamp(30px, 3.3vw, 50px)",
                letterSpacing: "-0.035em",
                lineHeight: "1.02",
                margin: "0 0 44px",
                maxWidth: "20em",
              }}
            >
              De la demande au jour J, quatre étapes
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: 1,
                background: "rgba(17,17,17,0.14)",
                border: "1px solid rgba(17,17,17,0.14)",
                borderRadius: 18,
                overflow: "hidden",
              }}
            >
              <div style={{ background: "#FFFFFF", padding: "28px 24px 32px" }}>
                <span
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#1B5B8C",
                  }}
                >
                  01
                </span>
                <h3
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 600,
                    fontSize: 19,
                    letterSpacing: "-0.02em",
                    margin: "14px 0 9px",
                  }}
                >
                  Votre brief
                </h3>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.55",
                    color: "rgba(17,17,17,0.66)",
                    margin: 0,
                  }}
                >
                  Un formulaire et quelques lignes de brief à nous donner et un
                  de nos commerciaux vous rappelle et cadre le besoin.
                </p>
              </div>
              <div style={{ background: "#FFFFFF", padding: "28px 24px 32px" }}>
                <span
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#1B5B8C",
                  }}
                >
                  02
                </span>
                <h3
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 600,
                    fontSize: 19,
                    letterSpacing: "-0.02em",
                    margin: "14px 0 9px",
                  }}
                >
                  Devis sous 24 h
                </h3>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.55",
                    color: "rgba(17,17,17,0.66)",
                    margin: 0,
                  }}
                >
                  Matériel, options, logistique et budget détaillés, sans
                  engagement.
                </p>
              </div>
              <div style={{ background: "#FFFFFF", padding: "28px 24px 32px" }}>
                <span
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#1B5B8C",
                  }}
                >
                  03
                </span>
                <h3
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 600,
                    fontSize: 19,
                    letterSpacing: "-0.02em",
                    margin: "14px 0 9px",
                  }}
                >
                  Création graphique
                </h3>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.55",
                    color: "rgba(17,17,17,0.66)",
                    margin: 0,
                  }}
                >
                  Cadre photo, écrans et habillage de borne à votre charte. Bon
                  à tirer avant production, avec l'accompagnement d'un de nos
                  chargés de projet.
                </p>
              </div>
              <div style={{ background: "#FFFFFF", padding: "28px 24px 32px" }}>
                <span
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#1B5B8C",
                  }}
                >
                  04
                </span>
                <h3
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 600,
                    fontSize: 19,
                    letterSpacing: "-0.02em",
                    margin: "14px 0 9px",
                  }}
                >
                  Jour J
                </h3>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.55",
                    color: "rgba(17,17,17,0.66)",
                    margin: 0,
                  }}
                >
                  Livraison, installation, démontage et hotline pendant tout
                  l'événement.
                </p>
              </div>
            </div>
          </section>
          <section
            id="avis"
            style={{
              padding: "0 clamp(20px, 4vw, 60px) clamp(48px, 5.5vw, 92px)",
              maxWidth: 1560,
              margin: "0 auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: 22,
                marginBottom: 34,
              }}
            >
              <h2
                style={{
                  fontFamily: "Montserrat, Helvetica, sans-serif",
                  fontWeight: 700,
                  fontSize: "clamp(30px, 3.3vw, 50px)",
                  letterSpacing: "-0.035em",
                  lineHeight: "1.02",
                  margin: 0,
                }}
              >
                Ils nous ont fait confiance
              </h2>
              <span
                style={{
                  fontFamily: "Montserrat, Helvetica, sans-serif",
                  fontSize: "12.5px",
                  color: "rgba(17,17,17,0.55)",
                }}
              >
                Avis vérifiés Trustpilot
              </span>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: 18,
              }}
            >
              <blockquote
                style={{
                  margin: 0,
                  background: "#F7F7F7",
                  border: "1px solid rgba(17,17,17,0.08)",
                  borderRadius: 18,
                  padding: "26px 24px 24px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  style={{
                    color: "#CE2D7B",
                    fontSize: 14,
                    letterSpacing: "0.14em",
                    marginBottom: 16,
                  }}
                >
                  ★★★★★
                </span>
                <h3
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 600,
                    fontSize: 18,
                    letterSpacing: "-0.02em",
                    margin: "0 0 12px",
                  }}
                >
                  Matériel très fiable
                </h3>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.6",
                    color: "rgba(17,17,17,0.7)",
                    margin: "0 0 22px",
                  }}
                >
                  « Je vous recommande de travailler avec ce prestataire, car
                  chaque interlocuteur est agréable et professionnel, le
                  matériel est très fiable, les habillages personnalisés de très
                  bonne qualité. »
                </p>
                <footer
                  style={{
                    marginTop: "auto",
                    fontSize: 13,
                    color: "rgba(17,17,17,0.5)",
                  }}
                >
                  Marie — avis Trustpilot, juin 2026
                </footer>
              </blockquote>
              <blockquote
                style={{
                  margin: 0,
                  background: "#F7F7F7",
                  border: "1px solid rgba(17,17,17,0.08)",
                  borderRadius: 18,
                  padding: "26px 24px 24px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  style={{
                    color: "#CE2D7B",
                    fontSize: 14,
                    letterSpacing: "0.14em",
                    marginBottom: 16,
                  }}
                >
                  ★★★★★
                </span>
                <h3
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 600,
                    fontSize: 18,
                    letterSpacing: "-0.02em",
                    margin: "0 0 12px",
                  }}
                >
                  Tout parfait !
                </h3>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.6",
                    color: "rgba(17,17,17,0.7)",
                    margin: "0 0 22px",
                  }}
                >
                  Super expérience avec Wizito ! Une organisation impeccable,
                  une équipe réactive et des installateurs ponctuels et
                  efficaces. La piscine à balles a fait un carton auprès des
                  participants. Je recommande à 100% !
                </p>
                <footer
                  style={{
                    marginTop: "auto",
                    fontSize: 13,
                    color: "rgba(17,17,17,0.5)",
                  }}
                >
                  Méline Jacquin — avis Trustpilot, 23 janv. 2025
                </footer>
              </blockquote>
              <blockquote
                style={{
                  margin: 0,
                  background: "#F7F7F7",
                  border: "1px solid rgba(17,17,17,0.08)",
                  borderRadius: 18,
                  padding: "26px 24px 24px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  style={{
                    color: "#CE2D7B",
                    fontSize: 14,
                    letterSpacing: "0.14em",
                    marginBottom: 16,
                  }}
                >
                  ★★★★★
                </span>
                <h3
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 600,
                    fontSize: 18,
                    letterSpacing: "-0.02em",
                    margin: "0 0 12px",
                  }}
                >
                  Grande qualité !!!
                </h3>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.6",
                    color: "rgba(17,17,17,0.7)",
                    margin: "0 0 22px",
                  }}
                >
                  Entreprise très professionnelle et facilement joignable. Le
                  photobooth était très stable, les photos sont de très bonne
                  qualité et la dimension est parfaite ( type Polaroïd ). Il a
                  été très simple de personnaliser le fond. Beaucoup de choix.
                  La livraison a été très rapide. Le photobooth a été une
                  animation très appréciée par tous les invités!!! Je recommande
                  à 100% Wizito !!!
                </p>
                <footer
                  style={{
                    marginTop: "auto",
                    fontSize: 13,
                    color: "rgba(17,17,17,0.5)",
                  }}
                >
                  Malo — avis Trustpilot, 6 mai 2026
                </footer>
              </blockquote>
            </div>
          </section>
          <section
            id="devis"
            style={{
              background: "#F7F7F7",
              borderTop: "1px solid rgba(17,17,17,0.1)",
              padding: "clamp(48px, 5.5vw, 96px) clamp(20px, 4vw, 60px)",
            }}
          >
            <div
              style={{
                maxWidth: 1240,
                margin: "0 auto",
                display: "grid",
                gridTemplateColumns: "0.85fr 1.15fr",
                gap: "clamp(32px, 4vw, 72px)",
              }}
            >
              <div>
                <p
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontSize: "11.5px",
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    color: "#CE2D7B",
                    margin: "0 0 14px",
                  }}
                >
                  Votre devis
                </p>
                <h2
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontWeight: 700,
                    fontSize: "clamp(30px, 3.2vw, 48px)",
                    letterSpacing: "-0.035em",
                    lineHeight: "1.02",
                    margin: "0 0 20px",
                  }}
                >
                  Parlons de votre événement
                </h2>
                <p
                  style={{
                    fontSize: 16,
                    lineHeight: "1.62",
                    color: "rgba(17,17,17,0.68)",
                    margin: "0 0 30px",
                    textWrap: "pretty",
                  }}
                >
                  Décrivez votre besoin, un commercial vous répond avec un devis
                  chiffré sous 24 h. Aucun engagement, et le conseil est
                  gratuit.
                </p>
                <ul
                  style={{
                    listStyle: "none",
                    margin: "0 0 32px",
                    padding: 0,
                    display: "grid",
                    gap: 14,
                    fontSize: "14.5px",
                  }}
                >
                  <li style={{ display: "flex", gap: 11 }}>
                    <span style={{ color: "#1B5B8C" }}>—</span>Réponse sous 24 h
                  </li>
                  <li style={{ display: "flex", gap: 11 }}>
                    <span style={{ color: "#1B5B8C" }}>—</span>Un interlocuteur
                    unique jusqu'au jour J
                  </li>
                  <li style={{ display: "flex", gap: 11 }}>
                    <span style={{ color: "#1B5B8C" }}>—</span>Livraison,
                    installation et reprise incluses
                  </li>
                  <li style={{ display: "flex", gap: 11 }}>
                    <span style={{ color: "#1B5B8C" }}>—</span>Facturation
                    entreprise, bon de commande accepté
                  </li>
                </ul>
                <div
                  style={{
                    borderTop: "1px solid rgba(17,17,17,0.12)",
                    paddingTop: 24,
                    fontSize: "14.5px",
                    lineHeight: "1.7",
                    color: "rgba(17,17,17,0.68)",
                  }}
                >
                  Vous préférez le téléphone ?<br />
                  <a
                    href="tel:0184606164"
                    style={{
                      fontFamily: "Montserrat, Helvetica, sans-serif",
                      fontWeight: 700,
                      fontSize: 20,
                      letterSpacing: "-0.02em",
                    }}
                  >
                    01 84 60 61 64
                  </a>
                  <br />
                  <a
                    href="mailto:sales@wizito.com"
                    style={{ color: "rgba(17,17,17,0.68)" }}
                  >
                    sales@wizito.com
                  </a>
                </div>
              </div>
              <Form locale={"fr"} defaultType={"professional"} inline />
            </div>
          </section>
          <footer
            style={{
              background: "#111111",
              color: "rgba(255,255,255,0.65)",
              padding: "clamp(40px, 4.5vw, 68px) clamp(20px, 4vw, 60px) 108px",
            }}
          >
            <div
              style={{
                maxWidth: 1560,
                margin: "0 auto",
                display: "grid",
                gridTemplateColumns: "1.4fr auto",
                justifyContent: "space-between",
                gap: 48,
                paddingBottom: 36,
                borderBottom: "1px solid rgba(255,255,255,0.14)",
              }}
            >
              <div>
                <img
                  src="https://www.wizito.com/logo-blanc.png"
                  alt="Logo Wizito"
                  style={{
                    maxWidth: "112px",
                  }}
                ></img>
                <p
                  style={{
                    fontSize: "14.5px",
                    lineHeight: "1.6",
                    margin: "14px 0 0",
                    maxWidth: "26em",
                  }}
                >
                  Location de bornes photo made in France pour l'événementiel
                  professionnel.
                </p>
              </div>
              <div
                style={{
                  display: "grid",
                  gap: 11,
                  fontSize: 14,
                  alignContent: "start",
                }}
              >
                <span
                  style={{
                    fontFamily: "Montserrat, Helvetica, sans-serif",
                    fontSize: 11,
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,0.4)",
                  }}
                >
                  Contact
                </span>
                <span>01 84 60 61 64</span>
                <span>sales@wizito.com</span>
                <a
                  href="https://www.wizito.com/mentions-legales"
                  style={{ color: "inherit" }}
                  style-hover="color: #FFFFFF"
                >
                  Mentions légales
                </a>
              </div>
            </div>
            <p
              style={{
                maxWidth: 1560,
                margin: "22px auto 0",
                fontSize: "12.5px",
                color: "rgba(255,255,255,0.4)",
              }}
            >
              © 2026 Wizito. Tous droits réservés.
            </p>
          </footer>
          <template id="__bundler_thumbnail" />
          <sc-if value="{{ showStickyCta }}" hint-placeholder-val="{{ true }}">
            <div
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 70,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 22,
                padding: "14px 24px",
                background: "rgba(17,17,17,0.94)",
                backdropFilter: "blur(12px)",
                color: "#FFFFFF",
              }}
            >
              <span
                style={{ fontSize: "14.5px", color: "rgba(255,255,255,0.75)" }}
              >
                Un événement à animer ? Devis chiffré sous 24 h.
              </span>
              <a
                href="#devis"
                style={{
                  background: "#FFFFFF",
                  color: "#111111",
                  padding: "11px 22px",
                  borderRadius: 999,
                  fontSize: 14,
                  fontWeight: 700,
                }}
                style-hover="background: #CE2D7B; color: #FFFFFF"
              >
                Demander un devis
              </a>
            </div>
          </sc-if>
        </div>
      </x-dc>
    </>
  )
}
export default CampaignPage
